var _rect, _circle, _circle2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPositionSearchDisabledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.978516,
    y: 0.142822,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#dadada"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.9785,
    cy: 22.1428,
    r: 11.4,
    stroke: "#0047FF",
    strokeWidth: 1.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.9785,
    cy: 22.1428,
    r: 2,
    fill: "#0047FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9785 22.1428L14.9785 22.1428",
    stroke: "#0047FF",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9785 22.1428L33.9785 22.1428",
    stroke: "#0047FF",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9785 11.1428L22.9785 14.1428",
    stroke: "#0047FF",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9785 30.1428L22.9785 33.1428",
    stroke: "#0047FF",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionSearchDisabledIcon);
export default __webpack_public_path__ + "static/media/positionSearchDisabledIcon.edb80d7da654f46c6455d17bc0898f9c.svg";
export { ForwardRef as ReactComponent };